import React from 'react';
import { StaticPage } from '../StaticPage';
import { useLanguage } from '../../i18n/useLanguage';

export const AboutPage: React.FC = () => {
  const { language } = useLanguage();
  return (
    <StaticPage titleKey="static.about">
      {language === 'de' ? <AboutContentDe /> : <AboutContentEn />}
    </StaticPage>
  );
};

const AboutContentDe: React.FC = () => (
  <>
    <p>
      <strong>I Think It&apos;s You</strong> ist aus einer sehr einfachen, sehr menschlichen und zugegeben manchmal
      herrlich tragikomischen Situation entstanden:
    </p>
    <p>
      <strong>
        Man sieht sich, man findet sich sympathisch, man sagt nichts – und drei Minuten später fällt einem der perfekte
        Satz ein.
      </strong>
    </p>
    <p>Großartig. Nur leider zu spät.</p>
    <p>
      Genau für diese Momente gibt es <strong>I Think It&apos;s You</strong>: die charmante zweite Chance für verpasste
      Begegnungen bei <strong>Crime Club Events</strong>, bei Singles &amp; Social und überall dort, wo ein Blick mehr
      gesagt hat als ein ganzer Small Talk.
    </p>
    <p>
      Denn bei uns geht es nicht um hektisches Wegswipen, Profilakrobatik oder algorithmische Liebesorakel. Es geht um
      echte Begegnungen im echten Leben – um Situationen, die nicht künstlich organisiert werden, sondern einfach
      passieren. <strong>I Think It&apos;s You</strong> macht aus solchen Zufällen eine Möglichkeit: Wer die Gelegenheit
      versäumt hat, kann den Moment beschreiben, eine Spur hinterlassen und darauf hoffen, dass genau die richtige
      Person mitliest.
    </p>
    <p>
      Mit dem stillen Zeichen <strong>:|:</strong> bekommt dieses Prinzip sogar seinen eigenen Code – leise, charmant
      und unverwechselbar.
    </p>
    <p>
      Was als besondere Brücke für unsere Gäste und Besucherinnen und Besucher aller <strong>Crime Club</strong>-Formate
      gedacht ist, darf gern größer werden: zu einer Plattform für alle, die irgendwann schon einmal gedacht
      haben: <em>„Verdammt, ich hätte etwas sagen sollen.“</em>
    </p>
    <p>
      Ob nach einem Event, im Theaterfoyer, im Café, im Zug, auf Reisen oder zwischen Aperitif und Alibi – jede
      verpasste Gelegenheit verdient zumindest die Chance auf einen zweiten Auftritt.
    </p>
    <p>
      Und genau darin liegt der Charme von <strong>I Think It&apos;s You</strong>:
    </p>
    <p>
      Ein bisschen geheim, ein bisschen spielerisch, ein bisschen Herzklopfen – und im besten Fall der Anfang einer
      Geschichte, die beim ersten Mal einfach zu früh vorbei war.
    </p>
    <p>Oder, um es mit einem Augenzwinkern im <strong>Crime-Club</strong>-Stil zu sagen:</p>
    <p className="static-page-quote">
      <strong>Nicht jede Spur führt sofort zum Ziel. Aber manche lösen den schönsten Fall des Abends.</strong>
    </p>
  </>
);

const AboutContentEn: React.FC = () => (
  <>
    <p>
      <strong>I Think It&apos;s You</strong> started from a very simple, very human, and admittedly sometimes wonderfully
      tragicomic situation:
    </p>
    <p>
      <strong>
        You see each other, you click, you say nothing — and three minutes later the perfect line comes to mind.
      </strong>
    </p>
    <p>Wonderful. Just too late.</p>
    <p>
      That&apos;s exactly what <strong>I Think It&apos;s You</strong> is for: a charming second chance for missed
      connections at <strong>Crime Club events</strong>, at Singles &amp; Social, and anywhere a glance said more than
      a whole round of small talk.
    </p>
    <p>
      We&apos;re not about frantic swiping, profile acrobatics, or algorithmic love oracles. We&apos;re about real
      encounters in real life — moments that aren&apos;t staged but simply happen.{' '}
      <strong>I Think It&apos;s You</strong> turns those coincidences into a possibility: if you missed your moment, you
      can describe it, leave a trace, and hope exactly the right person reads along.
    </p>
    <p>
      With the quiet sign <strong>:|:</strong>, that idea even gets its own code — subtle, charming, and unmistakable.
    </p>
    <p>
      What began as a special bridge for our guests and visitors across every <strong>Crime Club</strong> format is
      welcome to grow: into a platform for anyone who has ever thought,{' '}
      <em>&ldquo;Damn, I should have said something.&rdquo;</em>
    </p>
    <p>
      Whether after an event, in the theatre foyer, at a café, on the train, while travelling, or between aperitif and
      alibi — every missed opportunity deserves at least the chance of a second curtain call.
    </p>
    <p>That&apos;s the charm of <strong>I Think It&apos;s You</strong>:</p>
    <p>
      A little secret, a little playful, a little flutter — and at best the beginning of a story that simply ended too
      soon the first time around.
    </p>
    <p>Or, with a wink in true <strong>Crime Club</strong> style:</p>
    <p className="static-page-quote">
      <strong>Not every clue leads straight to the answer. But some crack the most beautiful case of the night.</strong>
    </p>
  </>
);
